import * as THREE from 'three';

/**
 * Load an image with caching for faster subsequent loads.
 * Uses THREE.Cache for in-session reuse and native Image loading so the
 * browser can cache the response (faster on refresh/revisit).
 */
const loadCachedImage = (url, onLoad, onProgress, onError) => {
  const cached = THREE.Cache.get(url);

  if (cached !== undefined) {
    if (onLoad) {
      setTimeout(() => {
        if (onProgress) onProgress({ loaded: 1, total: 1 });
        onLoad(cached);
      }, 0);
    }
    return cached;
  }

  const image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img');

  const onImageLoaded = () => {
    THREE.Cache.add(url, image);
    if (onProgress) onProgress({ loaded: 1, total: 1 });
    if (onLoad) onLoad(image);
  };

  const onImageError = (e) => {
    if (onError) onError(e);
  };

  image.addEventListener('load', onImageLoaded, false);
  image.addEventListener('error', onImageError, false);

  // Data URLs: load directly
  if (url.indexOf('data:') === 0) {
    image.src = url;
    return image;
  }

  // Same-origin or CORS-friendly URLs: use native loading so the browser
  // can cache the image (faster on refresh and when navigating back)
  if (onProgress) onProgress({ loaded: 0, total: 1 });
  image.crossOrigin = 'anonymous';
  image.src = url;

  return image;
};

export default loadCachedImage;
